<template>
  <q-dialog
    v-model="open[refs]"
    no-refocus
    :maximized="isMaximizedMode"
    :persistent="persistent"
    :no-backdrop-dismiss="noBackdropDismiss"
    :no-esc-dismiss="noEscDismiss"
    @escape-key="beforeClose"
    @before-show="beforeShow"
    @before-hide="$emit('onHide')"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white" :style="style">
      <q-header class="bg-white" bordered>
        <q-toolbar :class="classes" class="q-pa-md">
          <layout-modal-header
            :before-close="beforeClose"
            :title="title"
            :header-search-bar="headerSearchBar"
            :sub-title="subTitle"
          />
        </q-toolbar>
      </q-header>
      <q-footer class="bg-white q-py-md" bordered>
        <q-toolbar :class="classes" class="border-top q-pb-sm">
          <layout-modal-footer
            :before-close="beforeClose"
            :is-loading="isLoading"
            :footer-button-one-action="footerButtonOneTrigger"
            :button-one-disable="footerButtonOneDisable"
            :button-one="footerButtonOne"
            :button-two="footerButtonTwo"
          >
            <template v-if="footerInfo" slot="info">
              <div :class="footerInfoClass">{{ footerInfo }}</div>
            </template>
          </layout-modal-footer>
        </q-toolbar>
      </q-footer>
      <q-page-container class="q-ma-md">
        <slot slot-scope="props" name="modal-data" />
      </q-page-container>
      <Loader :visible="getIsLoading" />
    </q-layout>
  </q-dialog>
</template>
<script>
import layoutModalHeader from 'src/application/global/components/common/header/layoutModalHeader'
import layoutModalFooter from 'src/application/global/components/common/footer/layoutModalFooter'
import { OpenCloseFormMixin } from 'src/application/global/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'LayoutModal',
  components: {
    layoutModalHeader,
    layoutModalFooter,
  },
  mixins: [OpenCloseFormMixin],
  props: {
    urlResetPathName: {
      type: String,
    },
    maximize: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: 'unset',
    },
    maxWidth: {
      type: String,
      default: 'unset',
    },
    minHeight: {
      type: String,
      default: 'unset',
    },
    maxHeight: {
      type: String,
      default: 'unset',
    },
    noBackdropDismiss: {
      type: Boolean,
      default: true,
    },
    noEscDismiss: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: 'transparent text-black',
    },
    headerLine: {
      type: Boolean,
      default: true,
    },
    headerSearchBar: {
      type: Boolean,
      default: false,
    },
    footerButtonOne: {
      type: String,
    },
    footerButtonTwo: {
      type: String,
    },
    footerButtonOneAction: {
      type: Function,
      required: false,
    },
    footerButtonTwoAction: {
      type: Function,
      required: false,
    },
    footerButtonOneActionModalPersistent: {
      type: Boolean,
      default: false,
    },
    footerButtonOneDisable: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    beforeCloseAction: {
      type: Function,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    footerInfo: {
      type: String,
    },
    footerInfoClass: {
      type: String,
    },
    skipErrorsCheckingOnClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['getFormHasErrors', 'getIsLoading']),
    isMaximizedMode() {
      return !this.$q.screen.gt.xs || !this.$q.screen.gt.sm || !this.$q.screen.gt.md || this.maximize
    },
    style() {
      return this.$q.screen.gt.sm && !this.isMaximizedMode
        ? this.fixed
          ? `height: 80vh; width: 80vw`
          : `min-width:  ${this.minWidth}; min-height: ${this.minHeight}; max-height: ${this.maxHeight}; max-width: ${this.maxWidth}`
        : ''
    },
    isPersistModal() {
      return this.footerButtonOneActionModalPersistent
    },
  },
  methods: {
    async footerButtonOneTrigger() {
      if (typeof this.footerButtonOneAction === 'function') {
        await this.footerButtonOneAction()
        if (!this.isPersistModal && (!this.getFormHasErrors || this.skipErrorsCheckingOnClose)) {
          await this.openCloseModal({ name: this.refs, status: false })
        }
      } else {
        await this.beforeClose()
      }
    },
    async beforeShow() {
      this.$emit('before-show', true)
    },
    async beforeClose() {
      this.openCloseModal({ name: this.refs, status: false })
      if (typeof this.footerButtonTwoAction === 'function') {
        await this.footerButtonTwoAction()
      }
      if (this.urlResetPathName) {
        await this.$router.replace({ name: this.urlResetPathName })
      }
      if (typeof this.beforeCloseAction === 'function') {
        await this.beforeCloseAction()
      }
    },
  },
}
</script>
